import { render, staticRenderFns } from "./LearningLogo.vue?vue&type=template&id=fa0e9c6e&"
import script from "./LearningLogo.vue?vue&type=script&lang=ts&"
export * from "./LearningLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports